import React from 'react'
import Footer from '../Footer'
import ImageInkOne from '../ImageInkOne'

function ImgInkOne() {
    window.scrollTo(0,0);
    return (
        <>
            <ImageInkOne/>
            <Footer/>
        </>
    )
}

export default ImgInkOne
